import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StepsService } from '../../../../services/steps.service';
import { IInitializePasswordRequest } from '../../../../classes/initialize-password';
import { IVerifyCodeRequest } from '../../../../classes/http-requests';
import { IUserData } from '../../../../../globals/classes/userData';

@Component({
	selector: 'email-restore-container',
	template: require('./email-restore-container.component.html'),
})
export class EmailRestoreContainerComponent {
	@Input() verfiyCodeRequest: IVerifyCodeRequest;
	@Input() initRequest: IInitializePasswordRequest;
	@Input() public isLoginBigModalEnabled: boolean = false;
	@Input() public isCorporate: boolean = false;
	@Input() public userData: IUserData;
	@Output() emitResend: EventEmitter<boolean> = new EventEmitter(false);

	constructor(public stepsService: StepsService) {}

	resend(flag: boolean) {
		this.emitResend.emit(flag);
	}
}
